import Grid from '@mui/material/Grid';
import TextFieldComp from '../../../components/TextField/textFieldComp';
import Box from '@mui/material/Box';
import ButtonComp from '../../../components/Button/buttonComp';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const fields = [
    { name: 'ddValue', label: 'Dropdown Value', required: true },
    { name: 'category', label: 'Category', required: true },
    { name: 'subCategory', label: 'Sub Category', required: false },
];

function AddEditDropdownMaster({
    closeModal = () => { },
    type = 'add',
    selectedRowObject = {},
    addUpdateDropdownMasterApi,
}) {
    const validationSchema = Yup.object().shape({
        ddValue: Yup.string().trim().max(100, 'Maximum 100 characters allowed').required('Dropdown Value is required'),
        category: Yup.string().trim().max(100, 'Maximum 100 characters allowed').required('Category is required'),
        subCategory: Yup.string().trim().max(100, 'Maximum 100 characters allowed').nullable(),
    });

    const formik = useFormik({
        initialValues:
            type === 'add'
                ? {
                    id: 0,
                    ddValue: '',
                    category: '',
                    subCategory: '',
                    status: true,
                }
                : {
                    ...selectedRowObject,
                    subCategory: selectedRowObject?.subCategory ?? '',
                },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async values => {
            try {
                await addUpdateDropdownMasterApi(values);
                closeModal();
            } catch (error) {
                console.error('API Error:', error);
            }
        },
    });

    return (
        <form onSubmit={formik.handleSubmit} noValidate>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '48px' }}>
                <Grid container spacing={'16px'}>
                    {fields.map(field => (
                        <Grid item xs={12} md={6} key={field.name}>
                            <TextFieldComp
                                label={field.label}
                                name={field.name}
                                required={field.required}
                                value={formik.values[field.name] ?? ''}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched[field.name] &&
                                    Boolean(formik.errors[field.name])
                                }
                                errorMessage={
                                    formik.touched[field.name] && formik.errors[field.name]
                                }
                                onBlur={formik.handleBlur}
                                maxLength={100}
                            />
                        </Grid>
                    ))}
                </Grid>

                <Grid container spacing={'16px'}>
                    <Grid item xs={12} md={6}>
                        <ButtonComp
                            variant="outlined"
                            className="text-bold-16px"
                            value="Cancel"
                            height="48px"
                            width="100%"
                            padding="14px 24px"
                            textcolor="#F37021"
                            borderRadius="8px"
                            border="1px solid #F37021"
                            onClick={closeModal}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <ButtonComp
                            type="submit"
                            className="text-bold-16px"
                            value={type === 'add' ? 'Add' : 'Save'}
                            disabled={!formik.dirty || !formik.isValid}
                            gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
                            height="48px"
                            width="100%"
                            padding="14px 24px"
                            textcolor="#fff"
                            borderRadius="8px"
                        />
                    </Grid>
                </Grid>
            </Box>
        </form>
    );
}

AddEditDropdownMaster.propTypes = {
    closeModal: PropTypes.func,
    type: PropTypes.string,
    selectedRowObject: PropTypes.object,
    addUpdateDropdownMasterApi: PropTypes.func.isRequired,
};

export default AddEditDropdownMaster;
